import { ref, computed } from 'vue';
import { createEventHook, createGlobalState } from '@vueuse/core';
import { ExtraPageName } from '@patsnap/hiro-event-proxy';
import { GlobalProxy, } from '@patsnap/hiro-event-proxy';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AiFilterAgentCode } from '../constants';
import _ from 'lodash';
import { i18nSymbol } from '@/i18n';
export const useSmartFilter = createGlobalState(() => {
    const i18n = injectService(i18nSymbol);
    const smartFilterResults = ref([]);
    // 创建事件钩子
    const doFilterEventHook = createEventHook();
    const onDoFilterEvent = doFilterEventHook.on;
    const emitDoFilterEvent = doFilterEventHook.trigger;
    // 获取 Event Proxy 实例
    const globalProxy = injectService(GlobalProxy);
    function getSelectedPatentCategories(result) {
        let categories = [];
        if (result.selectedPatentPNs?.length) {
            // 勾选
            categories = [{
                    pns: result.selectedPatentPNs,
                    label: i18n.t('app.selected'),
                }];
        }
        else if (result.selected?.length) {
            // 选中指定类型
            const selectedTypes = result.selected.map(e => e.type);
            const patents = (result.patents || []).filter(item => {
                return _.intersection(selectedTypes, item.filterItem).length > 0;
            });
            categories = result.selected.map(item => ({
                pns: patents.map(e => e.pn),
                label: item.type,
            }));
        }
        else if (result.patents?.length) {
            // 选择全部
            categories = [{
                    pns: result.patents?.map(e => e.pn),
                    label: i18n.t('app.all'),
                }];
        }
        return categories;
    }
    const filter4SmartFilter = computed(() => {
        return smartFilterResults.value.map(item => {
            const selected = getSelectedPatentCategories(item);
            return {
                userInputText: item.userInputText,
                selected: selected.map(e => ({
                    type: e.label,
                    count: e.pns.length,
                })),
            };
        });
    });
    /** 同时移除后面的项 */
    function removeSmartFilterResult(index, doFilter) {
        // 同时移除后面的项
        smartFilterResults.value.splice(index, smartFilterResults.value.length - index);
        if (doFilter) {
            emitDoFilterEvent({
                smartFilterResults: _.cloneDeep(smartFilterResults.value),
            });
        }
    }
    function updateSmartFilterResult(index, result, doFilter) {
        smartFilterResults.value[index] = result;
        removeSmartFilterResult(index + 1);
        if (doFilter) {
            emitDoFilterEvent({
                smartFilterResults: _.cloneDeep(smartFilterResults.value),
            });
        }
    }
    /**
     * 增加智能过滤结果
     * 如果结果已存在，则更新结果
     * @param result 智能过滤结果
     */
    function appendSmartFilterResult(result, doFilter) {
        const index = _.findIndex(smartFilterResults.value, { messageId: result.messageId });
        if (index >= 0) {
            updateSmartFilterResult(index, result);
        }
        else {
            smartFilterResults.value.push(result);
        }
        if (doFilter) {
            emitDoFilterEvent({
                smartFilterResults: _.cloneDeep(smartFilterResults.value),
            });
        }
    }
    function setSmartFilterResults(results) {
        smartFilterResults.value = results || [];
    }
    function clearSmartFilterResults() {
        smartFilterResults.value = [];
        emitDoFilterEvent({
            smartFilterResults: _.cloneDeep(smartFilterResults.value),
        });
    }
    function buildSfq() {
        return smartFilterResults.value.map(item => item.filterId).join(',') || undefined;
    }
    function getSelectedPatentPNs(result) {
        const selectedPNs = getSelectedPatentCategories(result);
        return selectedPNs
            .map(e => e.pns)
            .flat();
    }
    function openHiroSmartFilter() {
        globalProxy.rpcHiro.call('openSidebar');
        globalProxy.rpcHiro.call('setCurrentMenu', 'HiroAgentManager');
        globalProxy.rpcHiro.call('switchAgent', { agentCode: AiFilterAgentCode, createNew: true });
    }
    function openExtraPageForSmartFilter(index) {
        const smartFilterResult = smartFilterResults.value[index];
        if (!smartFilterResult) {
            return;
        }
        globalProxy.rpcHiro.call('openExtraPage');
        globalProxy.rpcHiro.call('switchExtraPageContent', {
            routerName: ExtraPageName.AiPatentResult,
            params: {
                patentResults: smartFilterResult.patents.map(e => ({
                    patent_id: e.patentId,
                    filter_item: e.filterItem,
                    filter_reason: e.filterReason,
                })) || [],
                defaultSelectedPns: smartFilterResult.selectedPatentPNs,
                taskId: smartFilterResult.messageId,
                userInputText: smartFilterResult.userInputText,
                loadMore: false,
            },
        });
    }
    return {
        smartFilterResults,
        filter4SmartFilter,
        appendSmartFilterResult,
        removeSmartFilterResult,
        clearSmartFilterResults,
        setSmartFilterResults,
        buildSfq,
        getSelectedPatentPNs,
        openHiroSmartFilter,
        openExtraPageForSmartFilter,
        onDoFilterEvent,
        emitDoFilterEvent,
    };
});
